<template>
  <div
    v-if="hasChild"
    class="mg-space-item"
    :style="style"
    :class="{ 'mg-space-item__empty': isNoChildren, 'is-vertical': isVertical }"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'mgSpaceItem',
    computed: {
      isNoChildren() {
        return this.$slots.default === void 0
      },
      isVertical() {
        return this.$parent.direction === 'vertical'
      },
      style() {
        let cssProperty = 'margin-right'
        if (this.isVertical) {
          cssProperty = 'margin-bottom'
        }
        return {
          [cssProperty]: this.$parent.space + 'px',
        }
      },
      hasChild() {
        return this.$slots.default
      },
    },
  }
</script>

<style scoped lang="scss">
  .mg-space-item {
    display: flex;
    align-items: center;
    &.is-vertical {
      &:last-child {
        margin-bottom: 0px !important;
      }
    }
    &:last-child {
      margin-right: 0px !important;
    }
    &.mg-space-item__empty {
      margin-right: 0;
    }
  }
</style>
